import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import { SadFace } from '../../../../assets/images/index';

import {
  WrapperError,
  ParagraphError,
  ParagraphSearch,
  Paragraph
} from './style';

const ErrorPageSearch = ({ className, paragraphSearch }) => (
  <WrapperError className={className}>
    <Icon svg={SadFace} size="xl" />
    <ParagraphError>
      Lo sentimos, no encontramos ningún resultado para tu búsqueda
    </ParagraphError>
    <ParagraphSearch>
      <strong>
        {`"`}
        {paragraphSearch}
        {`"`}
      </strong>
    </ParagraphSearch>

    <Paragraph>Prueba una nueva búsqueda</Paragraph>
    {/* <ParagraphSmall>
      <LinkParagraph href="">Visista nuestro centro de ayuda</LinkParagraph>
    </ParagraphSmall> */}
  </WrapperError>
);

ErrorPageSearch.propTypes = {
  className: PropTypes.string,
  paragraphSearch: PropTypes.string
};

ErrorPageSearch.defaultProps = {
  paragraphSearch: ''
};

export default ErrorPageSearch;
